<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="privacy__background module__background"
        >
        </app-modulebackground>
        <div
            class="privacy__container module__container"
            v-bind:class="{ container__boxed: [1, 2].includes(module.layout.type) }"
        >
            <div class="privacy__inner module__inner">
                <div class="privacy__inner--main module__inner--main">
                    <div class="privacy__inner-row module__inner-row">
                        <div class="privacy__inner-col module__inner-col">
                            <div
                                class="legal-text"
                                v-bind:data-company="
                                    encodeURIComponent(JSON.stringify(getLegalUserData))
                                "
                                v-bind:data-has-package-basic="
                                    encodeURIComponent(JSON.stringify(hasPackageBasic))
                                "
                                v-bind:data-gmap-optinout-text="
                                    encodeURIComponent(JSON.stringify($helpers.uiText('F001')))
                                "
                                v-bind:data-youtube-optinout-text="
                                    encodeURIComponent(JSON.stringify($helpers.uiText('F002')))
                                "
                                v-bind:data-vimeo-optinout-text="
                                    encodeURIComponent(JSON.stringify($helpers.uiText('F003')))
                                "
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Privacy from '@/external/modules/Privacy';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getLegalUserData', 'hasPackageBasic'])
    },
    mounted() {
        let i = new Privacy();
        i.init(this.$refs.root);
    },
    updated() {
        let i = new Privacy();
        i.init(this.$refs.root);
    },
    props: {
        module: Object
    }
};
</script>
